const getCellByColumnRef = ({ cells, columnRef }) => {
  const cellArray = Object.values(cells);
  const foundCell = cellArray.find(cell => cell.columnRef === columnRef);
  return foundCell || null;
};

export default getCellByColumnRef;
